function openTermsModal() {
  document.getElementById('terms-snippet-container').style.display = 'block';
  document.body.classList.add('modal-open');
}

function closeTermsModal() {
  document.getElementById('terms-snippet-container').style.display = 'none';
  document.body.classList.remove('modal-open');
}
function openSizeModal() {
  document.getElementById('size-guide-container').style.display = 'block';
  document.body.classList.add('modal-open');
}

function closeSizeModal() {
  document.getElementById('size-guide-container').style.display = 'none';
  document.body.classList.remove('modal-open');
}
function openPolicyModal() {
  document.getElementById('policy-snippet-container').style.display = 'block';
  document.body.classList.add('modal-open');
}

function closePolicyModal() {
  document.getElementById('policy-snippet-container').style.display = 'none';
  document.body.classList.remove('modal-open');
}
function openShippingModal() {
  document.getElementById('shipping-snippet-container').style.display = 'block';
  document.body.classList.add('modal-open');
}
function closeShippingModal() {
  document.getElementById('shipping-snippet-container').style.display = 'none';
  document.body.classList.remove('modal-open');
}

function openGiftcardModal() {
  document.getElementById('giftcard-snippet-container').style.display = 'block';
  document.body.classList.add('modal-open');
}
function closeGiftcardModal() {
  document.getElementById('giftcard-snippet-container').style.display = 'none';
  document.body.classList.remove('modal-open');
}

// Make functions available globally if needed
window.openTermsModal = openTermsModal;
window.closeTermsModal = closeTermsModal;
window.openSizeModal = openSizeModal;
window.closeSizeModal = closeSizeModal;
window.openPolicyModal = openPolicyModal;
window.closePolicyModal = closePolicyModal;
window.openShippingModal = openShippingModal;
window.closeShippingModal = closeShippingModal;
window.openGiftcardModal = openGiftcardModal;
window.closeGiftcardModal = closeGiftcardModal;
